import * as React from 'react';
import { Field } from 'redux-form';

import { SegmentLabel } from '@acceligentllc/storybook';

import Checkbox from 'af-fields/Checkbox';
import Input from 'af-fields/Input';

import JobUpsertFM from '../../formModel';
import { formSectionClass, formSectionClassColumn1, formSectionClassColumn2, formSectionClassRow } from '../../helpers';
import styles from '../../styles.module.scss';

type Props = {
	isDisabled: boolean;
};

const JobDetailSection: React.FC<Props> = ({ isDisabled }) => {
	const taxExemptStyle = React.useMemo(() => [formSectionClassColumn2, styles['job-form__tab-content__form-section__row__centered-column']].join(' '), []);
	const unionPrevailingWageStyle = React.useMemo(() => [formSectionClassColumn1, styles['job-form__tab-content__form-section__row__centered-column']].join(' '), []);

	return (
		<div className={formSectionClass}>
			<SegmentLabel
				label="Job Details"
				tooltip="Additional details and references related to the ownership, contracting, tax configuration, and regulatory requirements of this job."
			/>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="projectOwner"
						label="Project Owner"
						name={JobUpsertFM.getAttributeName('projectOwner')}
						placeholder="Enter Project Owner"
						type="text"
					/>
				</div>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="ownerReference"
						label="Owner Reference"
						name={JobUpsertFM.getAttributeName('ownerReference')}
						placeholder="Enter Owner Reference"
						type="text"
					/>
				</div>
				<div className={taxExemptStyle}>
					<Field
						component={Checkbox}
						id="taxExempt"
						isDisabled={isDisabled}
						label="Tax Exempt"
						name={JobUpsertFM.getAttributeName('taxExempt')}
					/>
				</div>
			</div>

			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="generalContractor"
						label="General Contractor"
						name={JobUpsertFM.getAttributeName('generalContractor')}
						placeholder="Enter General Contractor"
						type="text"
					/>
				</div>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="contractorReference"
						label="Contractor Reference"
						name={JobUpsertFM.getAttributeName('contractorReference')}
						placeholder="Enter Contractor Reference"
						type="text"
					/>
				</div>
			</div>

			<div className={formSectionClassRow}>
				<div className={unionPrevailingWageStyle}>
					<Field
						component={Checkbox}
						id="union"
						isDisabled={isDisabled}
						label="Union"
						name={JobUpsertFM.getAttributeName('isUnion')}
					/>
				</div>
				<div className={unionPrevailingWageStyle}>
					<Field
						component={Checkbox}
						id="prevailingWage"
						isDisabled={isDisabled}
						label="Prevailing Wage"
						name={JobUpsertFM.getAttributeName('isPrevailingWage')}
					/>
				</div>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="jurisdiction"
						label="Jurisdiction"
						name={JobUpsertFM.getAttributeName('jurisdiction')}
						placeholder="Enter Jurisdiction"
						type="text"
					/>
				</div>
			</div>
		</div>
	);
};

export default React.memo(JobDetailSection);
